import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initSentry } from './utils/sentry';

initSentry();

// Polyfill for crypto.randomUUID - MUST run before any other code
// This fixes issues with browser extensions and older browsers
(function() {
  if (typeof window === 'undefined') return;
  
  // Ensure crypto object exists
  if (!window.crypto) {
    window.crypto = {};
  }
  
  // Polyfill randomUUID if not available
  if (!window.crypto.randomUUID) {
    window.crypto.randomUUID = function() {
      // Use crypto.getRandomValues if available, otherwise fallback to Math.random
      if (window.crypto.getRandomValues) {
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 0x0f) | 0x40; // Version 4
        bytes[8] = (bytes[8] & 0x3f) | 0x80; // Variant 10
        const hex = Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('');
        return [
          hex.slice(0, 8),
          hex.slice(8, 12),
          hex.slice(12, 16),
          hex.slice(16, 20),
          hex.slice(20, 32)
        ].join('-');
      } else {
        // Fallback to Math.random if getRandomValues not available
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = (Math.random() * 16) | 0;
          const v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
      }
    };
  }
  
  // Ensure getRandomValues exists
  if (!window.crypto.getRandomValues) {
    window.crypto.getRandomValues = function(arr) {
      for (let i = 0; i < arr.length; i++) {
        arr[i] = Math.floor(Math.random() * 256);
      }
      return arr;
    };
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
